module.exports = __webpack_public_path__ + "img/empty_icon.805b719c.svg";